module.exports = __webpack_public_path__ + "static/media/15.a7f88016.webp";